import React, {
  useContext,
  Suspense,
  useEffect,
  useRef,
  useState,
  useMemo,
  startTransition
} from "react";
import { isEmpty } from "../../helpers/utils";
import ContactSupportForm from '../ContactSupportForm';
import Voting from "../Voting/Voting";
import { translatePhenomenonAlias } from "../../helpers/utils";
import { finalTranslations } from "../../localTranslation";
import styles from "./CardHeader.module.css";
// import { ContentCardType } from "../ContentCardType";
import useSWR from "swr";
import { getPhenomenaStatistic } from "../../helpers/phenomenonFetcher";
import { votingApi } from "../../helpers/fetcher";
import trans from "./trans.svg";
import orginalTrans from "./orignalTrans.svg";
import arrow from "./arrow.svg";
import checked from "./checked.svg";
import g1 from "./greyscale-regular@2x.png";
import {innerDimensions} from '../../helpers/helpers'
import styled from "styled-components";
import { ContentCardType} from "@futures-platform/ui";
import _ from "lodash";
import { ACTIONS } from "../../store/Actions";
import { DataContext } from "../../store/GlobalState";
import {
  Modal,
  // paddingModalStyles,
} from "@futures-platform/ui";
import { PhenEditCardStyles } from "../../styles";
import ToggleSwitcher from "../PhenEditForm/ToggleSwitcher";
import { getContentTypeImageSrc } from "../../helpers/helpers";
import { getGroupInitials } from "../../helpers/groupInitials";
import GroupInitialsMark, { FpGroupMark, typeBubbleWrapStyle } from "../GroupInitialsMark";
import { requestTranslation } from "@futures-platform/i18n";
const langOptionList = [
  {
    label: "Finnish",
    value: "fi",
  },
  {
    label: "Spanish",
    value: "es",
  },
  {
    label: "German",
    value: "de",
  },
  {
    label: "French",
    value: "fr",
  },
  {
    label: "Portuguese",
    value: "pt",
  },
  {
    label: "Dutch",
    value: "nl",
  },
  {
    label: "Japanese",
    value: "ja",
  },
  {
    label: "Chinese",
    value: "zh",
  },
  {
    label: "Arabic",
    value: "ar",
  },
  {
    label: "Thai",
    value: "th",
  },
  {
    label: "Swedish",
    value: "sv",
  },
  {
    label: "Norwegian",
    value: "no",
  },
  {
    label: "Danish",
    value: "da",
  },
  {
    label: "Italian",
    value: "it",
  },
  {
    label: "Vietnamese",
    value: "vi",
  },
].sort(function (a, b) {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
});

function translationHtml(response) {
  const data = response && response.data;
  if (typeof data !== "string") {
    return "";
  }
  const visible = data
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return visible ? data : "";
}

function nextTranslation(result, previousResponse) {
  if (result && result.skipped) {
    return previousResponse ?? null;
  }
  const response = result && result.response;
  return translationHtml(response) ? response : null;
}

// const seletecTransHandler = (e) => {
//   const selectedFilter = _.find(langOptionList , { label: e.target.innerText });
//   setlangForTrans(() => selectedFilter)
//   dispatch({
//     type: ACTIONS.LANGFORTRANSSTATE,
//     payload: selectedFilter,
//   });
//   setisTransListShown(() => false)
//   setisTranslated(() => true)
// }
const CardHeader = ({
  userId,
  position,
  gid,
  rid,
  pid,
  phenomenon,
  lang,
  votingOn,
  groupRadarId,
  isTranslated,
  canEditContentCard,
  uri
}) => {
  const {
    state: { langForTransState, isAutoTrans, langListOpts, publicPhenomenaGroupsActived },
    dispatch,
  } = useContext(DataContext);
  const crowdsourcedRef = useRef()
  
  const langOptionList = useMemo(() => {
    if (!!langListOpts?.length) {
      return langListOpts?.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    } else return []
  }, [langListOpts])
  // const {iconClassName, backgroundColor} = phenomenonColor(phenomenon);
  const cardHeaderTitleRef = useRef();
  // const cardHeaderInfoRef = useRef();
  const cardHeaderSummaryRef = useRef();

  const typeNameRef = useRef() , timeRangeRef = useRef(), crSrcRef = useRef()
  // for store elms
  const cardHeaderTitleRef2 = useRef();
  // const cardHeaderInfoRef2 = useRef();
  const cardHeaderSummaryRef2 = useRef();

  const typeNameRef2 = useRef() , timeRangeRef2 = useRef(), crSrcRef2 = useRef()

  const [translations, settranslations] = useState(null);
  const [typeName, settypeName] = useState(
    () => typeNameRef2.current
  );
  const [timeRange, settimeRange] = useState(
    () => timeRangeRef2.current
  );
  const [crSrc, setcrSrc] = useState(
    () => crSrcRef2.current
  );

  const [originalTitle, setoriginalTitle] = useState(
    () => cardHeaderTitleRef2.current
  );
  // const [originalInfo, setoriginalInfo] = useState(
  //   () => cardHeaderInfoRef2.current
  // );
  const [originalSummary, setoriginalSummary] = useState(
    () => cardHeaderSummaryRef2.current
  );
  const [isOpenTransSettings, setisOpenTransSettings] = useState(false);

  const [langForTransTemp, setlangForTransTemp] = useState(langForTransState);

  const [isAutoTransTemp, setisAutoTransTemp] = useState(isAutoTrans);

  const { translationTitle } = translatePhenomenonAlias(phenomenon, lang);
  const { data: crowdsourcedData } = useSWR(
    `statistic/${gid}/${rid}/${pid}`,
    async () => {
      if (!!crowdsourcedRef.current) {
        return crowdsourcedRef.current
      }
      return await getPhenomenaStatistic(pid);
    }
  );

 
    useEffect(() => {
      if (!crowdsourcedRef.current) {
        crowdsourcedRef.current =  crowdsourcedData
      }
    }, [crowdsourcedData])

  const filteredByValue = React.useMemo(() => {
    return (
      !!(crowdsourcedData) &&
      Object.fromEntries(
        Object.entries(crowdsourcedData?.data).filter(
          ([key, value]) => key?.toString() === pid?.toString()
        )
      )
    );
  }, [crowdsourcedData, pid]);

  const statictis = React.useMemo(() => {
    return filteredByValue[pid];
  }, [filteredByValue, pid]);

  const crowdsourced = !!statictis
    ? String(statictis?.["year_median"])?.split(".")[0]
    : null;
  
    // useEffect(() => {
    //   if (!crowdsourcedRef.current) {
    //     crowdsourcedRef.current = crowdsourced
    //   }
    // }, [crowdsourced])

    // console.log(55555, crowdsourcedRef.current)
  useEffect(() => {
    if (!!phenomenon) {
      if (true) {
        if (
          !!cardHeaderTitleRef.current?.innerHTML &&
          !cardHeaderTitleRef2.current
        ) {
          cardHeaderTitleRef2.current = cardHeaderTitleRef.current?.innerHTML;
        }
        // if (
        //   !!cardHeaderInfoRef.current?.innerHTML &&
        //   !cardHeaderInfoRef2.current
        // ) {
        //   cardHeaderInfoRef2.current = cardHeaderInfoRef.current?.innerHTML;
        // }
        if (
          !!cardHeaderSummaryRef.current?.innerHTML &&
          !cardHeaderSummaryRef2.current
        ) {
          cardHeaderSummaryRef2.current =
            cardHeaderSummaryRef.current?.innerHTML;
        }

        if (
          !!typeNameRef.current?.innerHTML &&
          !typeNameRef2.current
        ) {
          typeNameRef2.current =
          typeNameRef.current?.innerHTML;
        }
        if (
          !!timeRangeRef.current?.innerHTML &&
          !timeRangeRef2.current
        ) {
          timeRangeRef2.current =
          timeRangeRef.current?.innerHTML;
        }
        if (
          !!crSrcRef.current?.innerHTML &&
          !crSrcRef2.current
        ) {
          crSrcRef2.current =
          crSrcRef.current?.innerHTML;
        }

        !!typeNameRef2.current &&
          !typeName &&
          settypeName(() => typeNameRef2.current);

          !!timeRangeRef2.current &&
          !timeRange &&
          settimeRange(() => timeRangeRef2.current);

          !!crSrcRef2.current &&
          !crSrc &&
          setcrSrc(() => crSrcRef2.current);






        !!cardHeaderTitleRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardHeaderTitleRef2.current);
        // !!cardHeaderInfoRef2.current &&
        //   !originalInfo &&
        //   setoriginalInfo(() => cardHeaderInfoRef2.current);
        !!cardHeaderSummaryRef2.current &&
          !originalSummary &&
          setoriginalSummary(() => cardHeaderSummaryRef2.current);

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD4,
        //   payload: true
        // })
      }
    }
  }, [
    isTranslated,
    phenomenon,
    dispatch,
    originalTitle,
    // originalInfo,
    originalSummary,
  ]);

  useEffect(() => {
    let isCurrent = true;
    const translateField = async (source) => {
      if (!source) {
        return { skipped: true };
      }
      try {
        const response = await votingApi.translation(
          "en",
          langForTransState,
          source
        );
        return { skipped: false, response };
      } catch (error) {
        return { skipped: false, response: null };
      }
    };
    const fetcher = async () => {
      const [res1, res2, res3, res4, res5] = await Promise.all([
        translateField(originalTitle || cardHeaderTitleRef2.current),
        translateField(originalSummary || cardHeaderSummaryRef2.current),
        translateField(typeName || typeNameRef2.current),
        translateField(timeRange || timeRangeRef2.current),
        translateField(crSrc || crSrcRef2.current),
      ]);
      if (!isCurrent) {
        return;
      }
      settranslations((previous) => {
        return {
          res1: nextTranslation(res1, previous?.res1),
          res2: nextTranslation(res2, previous?.res2),
          res3: nextTranslation(res3, previous?.res3),
          res4: nextTranslation(res4, previous?.res4),
          res5: nextTranslation(res5, previous?.res5),
        };
      });
    };
    if (isTranslated) {
      fetcher();
    }
    return () => {
      isCurrent = false;
    };
  }, [isTranslated, originalSummary, originalTitle, langForTransState, typeName, timeRange, crSrc]);

  const isFpGroup =
    Number(phenomenon?.group) === 0 ||
    (!!phenomenon?.groups?.length && Number(phenomenon?.groups[0]) === 0);
  const groupInitials = getGroupInitials(phenomenon?.group, publicPhenomenaGroupsActived)

    const contentTypeImageSrc = useMemo(() => {
      return getContentTypeImageSrc(phenomenon?.["color"], phenomenon?.["content-type-alias"], isFpGroup, 16)
    }, [phenomenon, isFpGroup])
  const seletecTransHandler = (e) => {
    const label = e?.target?.innerText
    const selectedFilter = _.find(langOptionList, {
      label: label
    });
    if (langForTransTemp === selectedFilter?.value) {
      setlangForTransTemp(() => null);
      setisAutoTransTemp(() => false);
    } else {
      setlangForTransTemp(() => selectedFilter?.value);
    }
    
    // dispatch({
    //   type: ACTIONS.LANGFORTRANSSTATE,
    //   payload: selectedFilter,
    // });
  };
  const setAutoTransByOnDefaultHandler = () => {
    setisAutoTransTemp(() => !isAutoTransTemp);
    // dispatch({
    //   type: ACTIONS.ISAUTOTRANS,
    //   payload: !isAutoTrans,
    // });
  };

  const cancelSetAutoTransSettingHandler = () => {
    setisOpenTransSettings(false);
    setlangForTransTemp(() => langForTransState);
    setisAutoTransTemp(() => isAutoTrans);
  };
  const doneSetAutoTransSettingHandler = async () => {
    const payload = {
      preferred_language: langForTransTemp ?? null,
      is_auto_translation: (!!isAutoTransTemp && !!langForTransTemp) ? 1 : 0,
    };

    await votingApi.editPreferredTrans(userId, payload);
    setisOpenTransSettings(false);
    dispatch({
      type: ACTIONS.LANGFORTRANSSTATE,
      payload: langForTransTemp ?? null,
    });
    dispatch({
      type: ACTIONS.ISAUTOTRANS,
      payload: (!!isAutoTransTemp && !!langForTransTemp) ? 1 : 0
    });

    // When user clicks Done btn, the content of card should be translated to the target languague,
    // because the user did indicate that he/she wants to translate the card when he/she selected
    // the target lang. So when clicking done, the content card should be translated, but this case
    // is NOT the auto-translation, so should NOT set isAutoTransTemp variable and call editPreferredTrans api
    // with payload is_auto_translation = 1 to set to auto-translation => just translating the content of card.
    if (!!langForTransTemp) {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: true,
      });
    } else {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: false,
      });
    }
  };


  useEffect(() => {
    startTransition(() => {
      dispatch({
        type: ACTIONS.DATAFORTRANSLATIONFROMCARDHEADER,
        payload: {
        title: translations?.res1?.data,
        summary: translations?.res2?.data,
        typeCardName: translations?.res3?.data,
        timeRange: translations?.res4?.data,
        crowdedSrc: translations?.res5?.data, 
        isFP: isFpGroup
      }
    })
    })
  }, [translations, dispatch, isFpGroup])
  useEffect(() => {
    dispatch({
      type: ACTIONS.CROWDSOURCED,
      payload: {
        crowdsourced
      }
    })  
  }, [crowdsourced, dispatch])
  const eventTimeoutRef = React.useRef(null)
  const [width, setWidth] = useState(0)

  const calcSizeRateTabWrapper = () => {
    const contentCardElm = document.getElementById('content-card-wrapper')

    setWidth(
      innerDimensions(contentCardElm).width
      )
  }

  React.useEffect(() => {
    calcSizeRateTabWrapper()
    return () => {
      window.removeEventListener('resize', calcSizeRateTabWrapper)
    }
  }, [])

  try {
    window.addEventListener('resize', function () {
      // clearTimeOut() resets the setTimeOut() timer
      // due to this the function in setTimeout() is 
      // fired after we are done resizing
      clearTimeout(eventTimeoutRef.current)
  
      // setTimeout returns the numeric ID which is used by
      // clearTimeOut to reset the timer
      eventTimeoutRef.current = setTimeout(calcSizeRateTabWrapper, 200);
    }, false)
  } catch (error) {
  }


  useEffect(() => {
    startTransition(() => {
      dispatch({
        type: ACTIONS.DATAFORTRANSLATIONTYPEIMAGE,
        payload: {
          contentTypeImageSrc
      }
      })
    })
  }, [contentTypeImageSrc, dispatch])

// const isSmallScreen = useMemo(() => {
//   const isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
//   return (!!isMobile || Number(width) <= 500) ? true : false  
// }, [width])


  return phenomenon && !isEmpty(phenomenon) ? (
    <>

      {(!isTranslated || !translationHtml(translations?.res1)) && (
        <h1 className={styles.h1Title} ref={cardHeaderTitleRef}>
          {phenomenon?.title || phenomenon?.short_title}
        </h1>
      )}
      {!!isTranslated && !!translationHtml(translations?.res1) && (
        <h1
          className={styles.h1Title}
          // ref={cardHeaderTitleRef}
          dangerouslySetInnerHTML={{ __html: translationHtml(translations?.res1) }}
        ></h1>
      )}
    
      <div className={styles.cardHeaderWrapper} style={{
        marginBottom: '0 !important'
      }}>
        {true && (
          <div className={styles.headerWrapper} 
          // ref={cardHeaderInfoRef}
          >
            {/* {
                phenomenon?.['color'] === 'none' && <div className={`icon-issue ${iconClassName}`} style={{marginTop: '2.5px'}}></div>
              }
              {
                phenomenon?.['color'] !== 'none' && <div className=' w_h_16' style={{backgroundColor: `${backgroundColor}`, marginTop: '6px', borderRadius: '9999px'}}></div>
              } */}
            {phenomenon?.["content-type-alias"] !== null && (
              <div
                className={styles.contentCardWrapper}
                style={typeBubbleWrapStyle(phenomenon?.["content-type-alias"])}
              >
                <ContentCardType
                  contentType={phenomenon?.["content-type-alias"]}
                  customTypeStyleColor={phenomenon?.["color"]}
                  isFpGroup={false}
                />
                {isFpGroup && <FpGroupMark typeAlias={phenomenon?.["content-type-alias"]} />}
                <GroupInitialsMark typeAlias={phenomenon?.["content-type-alias"]} initials={groupInitials} />
              </div>
            )}
            {
              (!isTranslated || !translationHtml(translations?.res3)) && (
                <p className={styles.phenTitle} ref={typeNameRef}>
              {phenomenon?.["color"] === "none"
                ? translationTitle
                : phenomenon?.["content-type-title"]}
            </p>
              )
            }
            {
              !!isTranslated && !!translationHtml(translations?.res3) && (
                <p className={styles.phenTitle} ref={typeNameRef} dangerouslySetInnerHTML={{ __html: translationHtml(translations?.res3) }}>
              {/* {phenomenon?.["color"] === "none"
                ? translationTitle
                : phenomenon?.["content-type-title"]} */}
            </p>
              )
            }
            {((!!phenomenon?.time_range && !!phenomenon?.time_range?.min) ||
              crowdsourced) && <span className={styles.verticalLine}></span>}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              {!!phenomenon?.time_range &&
                !!phenomenon?.time_range?.min &&
                !!phenomenon?.time_range?.max && (!isTranslated || !translationHtml(translations?.res4)) && (
                  <p className={styles.timeRange} ref={timeRangeRef}>{`${
                    !!phenomenon?.time_range?.min
                      ? phenomenon?.time_range?.min
                      : ""
                  } - ${
                    !!phenomenon?.time_range?.max
                      ? phenomenon?.time_range?.max
                      : ""
                  }`}</p>
                )}

                {!!phenomenon?.time_range &&
                !!phenomenon?.time_range?.min &&
                !!phenomenon?.time_range?.max && !!isTranslated && !!translationHtml(translations?.res4) && (
                  <p className={styles.timeRange} ref={timeRangeRef} dangerouslySetInnerHTML={{ __html: translationHtml(translations?.res4) }}></p>
                )}
              
            </div>
            {crowdsourced && <span className={styles.verticalLine}></span>}
            <Suspense fallback={""}>
                {(crowdsourced && (!isTranslated || !translationHtml(translations?.res5))) && (
                  <p className={styles.crowdsourced} ref={crSrcRef}>
                    {lang === "fi"
                      ? finalTranslations?.crowdSourcedPhenCard?.fi
                      : finalTranslations?.crowdSourcedPhenCard?.en}{" "}
                    { crowdsourced ?? ""}
                  </p>
                )}
                {!!isTranslated && !!translationHtml(translations?.res5) && (
                  <p className={styles.crowdsourced} ref={crSrcRef} dangerouslySetInnerHTML={{ __html: translationHtml(translations?.res5) }}>
                    {/* {lang === "fi"
                      ? finalTranslations?.crowdSourcedPhenCard?.fi
                      : finalTranslations?.crowdSourcedPhenCard?.en}{" "}
                    { crowdsourcedRef.current ?? ""} */}
                  </p>
                )}
              </Suspense>
          </div>
        )}
        {/* {!!isTranslated && (
          <div
            className={styles.headerWrapper}
            // ref={cardHeaderInfoRef}
            dangerouslySetInnerHTML={{ __html: translations?.res2?.data }}
          ></div>
        )} */}
      </div>

  
      {(!isTranslated || !translationHtml(translations?.res2)) && (
        <p
          ref={cardHeaderSummaryRef}
          className={styles.summaryData}
          style={{ color: "#333" }}
          dangerouslySetInnerHTML={{ __html: phenomenon?.summary }}
        ></p>
      )}
      {!!isTranslated && !!translationHtml(translations?.res2) && (
        <p
          // ref={cardHeaderSummaryRef}
          className={styles.summaryData}
          style={{ color: "#333" }}
          dangerouslySetInnerHTML={{ __html: translationHtml(translations?.res2) }}
        ></p>
      )}
    </>
  ) : null;
};

export default CardHeader;
export const EditButton = styled.img`
  cursor: pointer;
  margin-left: 16px;
  height: 24px;
  :hover {
    opacity: 0.8;
  }
`;
export const LangOptWRapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const LangOpt = styled.div`
  // isSelected #5ea236
  font-weight: 400;
  color: ${(props) => (!!props.isSelected ? "white" : "black")};
  background: ${(props) => (!!props.isSelected ? "#6fbf40" : "transparent")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(50% - 4.6px);
  border: 1px solid rgb(118 118 118 / 50%);
  padding: 14px;
  margin-bottom: 6px;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 14px;
  font-family: L10,Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  &:nth-child(odd) {
    margin-right: 3px;
  }
  &:nth-child(even) {
    margin-left: 3px;
  }
  :hover {
    background: ${(props) => (!!props.isSelected ? "#5ea236" : "#aaaaaa36")};
  }
`;
export const AutoTransWrapper = styled.div`
margin-top: 16px;
margin-bottom: 16px;
`;
export const CTAsWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
`;
const AskForMoreLangs = styled.button`
  background-color: transparent !important;
  color: #006998 !important;
  &:hover {
    color: white !important;
    background-color: #006998 !important;
  }

`;
